import React from "react";

export default function ColorFrame29({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <path
          fill="#D8E6FD"
          d="M25.017 89.155L97.256 29.88l80.308 59.275v123.939H25.017V89.155z"
        ></path>
        <rect
          width="13.697"
          height="135.248"
          x="32.094"
          y="70.369"
          fill="#FFDB21"
          rx="4.718"
          transform="rotate(-18.372 32.094 70.369)"
        ></rect>
        <rect
          width="11.795"
          height="135.248"
          x="52.538"
          y="69.007"
          fill="#FFDB21"
          rx="4.718"
          transform="rotate(-14.514 52.538 69.007)"
        ></rect>
        <rect
          width="14.835"
          height="135.248"
          x="94.214"
          y="33.659"
          fill="#FFDB21"
          rx="4.718"
          transform="rotate(-2.448 94.214 33.66)"
        ></rect>
        <rect
          width="14.579"
          height="135.248"
          fill="#FFDB21"
          rx="4.718"
          transform="scale(-1 1) rotate(-4.507 479.698 1658.158)"
        ></rect>
        <rect
          width="13.305"
          height="135.248"
          x="58.829"
          y="42.923"
          fill="#FFDB21"
          rx="4.718"
          transform="rotate(-12.237 58.829 42.923)"
        ></rect>
        <rect
          width="13.28"
          height="135.248"
          fill="#FFDB21"
          rx="4.718"
          transform="scale(-1 1) rotate(-9.332 231.534 991.172)"
        ></rect>
        <rect
          width="13.857"
          height="135.248"
          x="76.915"
          y="47.8"
          fill="#FFDB21"
          rx="4.718"
          transform="rotate(-9.105 76.915 47.8)"
        ></rect>
        <rect
          width="11.795"
          height="135.248"
          fill="#FFDB21"
          rx="4.718"
          transform="scale(-1 1) rotate(-7.724 266.035 1087.462)"
        ></rect>
        <path
          fill="#7A6FF7"
          d="M25.017 89.641l77.846 44.427 74.701-44.427v123.453H25.017V89.641z"
        ></path>
        <path
          fill="#D8E6FD"
          d="M135.495 91.674a6.29 6.29 0 016.273-6.75h118.999a6.29 6.29 0 016.276 6.717l-12.144 178.496a6.291 6.291 0 01-6.276 5.863h-93.776a6.29 6.29 0 01-6.274-5.831L135.495 91.674z"
        ></path>
        <rect
          width="143.111"
          height="45.607"
          x="128.598"
          y="53.47"
          fill="#FF4747"
          rx="6.291"
        ></rect>
        <rect
          width="4.718"
          height="45.607"
          x="187.573"
          y="53.47"
          fill="#FF4747"
          rx="2.359"
        ></rect>
        <rect
          width="4.718"
          height="45.607"
          x="166.342"
          y="53.47"
          fill="#FF4747"
          rx="2.359"
        ></rect>
        <rect
          width="4.718"
          height="45.607"
          x="145.111"
          y="53.47"
          fill="#FF4747"
          rx="2.359"
        ></rect>
        <rect
          width="4.718"
          height="45.607"
          x="208.803"
          y="53.47"
          fill="#FF4747"
          rx="2.359"
        ></rect>
        <rect
          width="4.718"
          height="45.607"
          x="230.034"
          y="53.47"
          fill="#FF4747"
          rx="2.359"
        ></rect>
        <rect
          width="4.718"
          height="45.607"
          x="251.265"
          y="53.47"
          fill="#FF4747"
          rx="2.359"
        ></rect>
        <path
          fill="#FFDB21"
          d="M5.1 191.316a9.043 9.043 0 019.043-9.043h145.729a9.043 9.043 0 010 18.086H14.143a9.043 9.043 0 01-9.043-9.043z"
        ></path>
        <path
          fill="#FF4747"
          d="M14 214c0-11.046 8.954-20 20-20h119c6.627 0 12 5.373 12 12s-5.373 12-12 12H18a4 4 0 01-4-4z"
        ></path>
        <path
          fill="#FFDB21"
          d="M5 221.5a7.5 7.5 0 017.5-7.5h147a7.5 7.5 0 010 15h-147a7.5 7.5 0 01-7.5-7.5z"
        ></path>
        <path
          fill="#A76965"
          d="M167 179.553C167 157.156 148.844 139 126.447 139H43.553C21.156 139 3 157.156 3 179.553A6.447 6.447 0 009.447 186h151.106a6.446 6.446 0 006.447-6.447zM167 235.447C167 257.844 148.844 276 126.447 276H43.553C21.156 276 3 257.844 3 235.447A6.447 6.447 0 019.447 229h151.106a6.446 6.446 0 016.447 6.447z"
        ></path>
        <circle cx="37" cy="160" r="2" fill="#fff"></circle>
        <circle cx="47" cy="171" r="2" fill="#fff"></circle>
        <circle cx="62" cy="163" r="2" fill="#fff"></circle>
        <circle cx="53" cy="150" r="2" fill="#fff"></circle>
        <circle cx="70" cy="149" r="2" fill="#fff"></circle>
        <circle cx="17" cy="173" r="2" fill="#fff"></circle>
        <circle cx="23" cy="154" r="2" fill="#fff"></circle>
        <ellipse cx="201" cy="175.5" fill="#7A6FF7" rx="30" ry="29.5"></ellipse>
        <rect
          width="135"
          height="135"
          x="71"
          y="110"
          fill="#fff"
          stroke="#FF4747"
          strokeWidth="12"
          rx="20"
        ></rect>
        <path
          fill="#7A6FF7"
          d="M195.649 19.658a4.718 4.718 0 014.718-4.718h.786a4.718 4.718 0 014.718 4.718V53.47h-10.222V19.658z"
        ></path>
        <rect
          width="10.222"
          height="37.589"
          x="168.915"
          y="8.987"
          fill="#7A6FF7"
          rx="4.718"
          transform="rotate(-61.541 168.915 8.987)"
        ></rect>
        {children}
      </g>
    </svg>
  );
}
